export default "__VITE_ASSET__HJYJJGDy__"